var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: _vm.modalId, tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "modal-header d-flex justify-content-between align-items-start"
              },
              [
                _c("div", [
                  _c("h5", { staticClass: "mb-0" }, [
                    _vm._v(
                      _vm._s(_vm.$t("txtDutyName")) +
                        " - " +
                        _vm._s(this.duty.title || "NA")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("txtStartDate")) +
                        ": " +
                        _vm._s(_vm.formatDateTime(_vm.activity.startDate)) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "mx-1" }, [_vm._v("|")]),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          Math.floor(
                            (Date.now() - _vm.activity.startDate) /
                              (1000 * 60 * 60 * 24)
                          )
                        ) +
                        " " +
                        _vm._s(_vm.$t("generalDays")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "mx-1" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge badge-primary p-2" }, [
                    _c("i", { staticClass: "fas fa-user-edit mr-1" }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("txtLastUpdate")) +
                        ":\n                "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.activity.username))]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.formatDateTime(_vm.activity.currentDate)) +
                          ")"
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row mx-0 mb-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn col",
                    class: { "btn-primary": _vm.tab === 1 },
                    on: {
                      click: function($event) {
                        _vm.tab = 1
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-file-signature" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("txtDutyBasic")) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn col",
                    class: { "btn-primary": _vm.tab === 2 },
                    on: {
                      click: function($event) {
                        _vm.tab = 2
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-tasks" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("txtTaskInfo")) +
                        "\n                    "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === 1,
                      expression: "tab === 1"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row mx-0" }, [
                    _c("div", { staticClass: "col-md-7 py-3" }, [
                      _c("div", { staticClass: "d-flex flex-column pr-md-4" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "info-row d-flex justify-content-between border-bottom py-2"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-muted small text-uppercase"
                              },
                              [_vm._v(_vm._s(_vm.$t("txtDuty")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold text-right" },
                              [_vm._v(_vm._s(_vm.duty.title || "NA"))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.activity.title
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "info-row d-flex justify-content-between border-bottom py-2"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-muted small text-uppercase"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("txtActivityTitle")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-bold text-right"
                                  },
                                  [_vm._v(_vm._s(_vm.activity.title))]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activity.cellName
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "info-row d-flex justify-content-between border-bottom py-2"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-muted small text-uppercase"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("txtCellName")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-bold text-right"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-primary",
                                        attrs: {
                                          href:
                                            _vm.baseUrl +
                                            "quick?cell=" +
                                            _vm.activity.cellId
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(_vm.activity.cellName) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "info-row d-flex justify-content-between border-bottom py-2"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-muted small text-uppercase"
                              },
                              [_vm._v(_vm._s(_vm.$t("cellCostPlanned")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold text-right" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.boolenYesNoStr(_vm.activity.isPlaned)
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.activity.fkUserResponsibleName
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "info-row d-flex justify-content-between border-bottom py-2"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-muted small text-uppercase"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("txtResponsibles")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-bold text-right"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.activity.fkUserResponsibleName)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "info-row d-flex justify-content-between border-bottom py-2"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-muted small text-uppercase"
                              },
                              [_vm._v(_vm._s(_vm.$t("txtActivityReference")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold text-right" },
                              [
                                _vm.activity.reference
                                  ? [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(_vm.activity.reference) +
                                          "\n                            "
                                      )
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-muted font-italic font-weight-normal small"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("txtEmpty")) +
                                              "\n                              "
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5 py-3 bg-light-soft" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "info-row d-flex justify-content-between py-2 mb-3"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-muted small text-uppercase" },
                            [_vm._v(_vm._s(_vm.$t("activityPrio")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold" },
                            [
                              _vm.activity.priority
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "badge",
                                        style: _vm.priorityBadgeStyle
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.activity.priority.name)
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c(
                                      "span",
                                      { staticClass: "text-muted small" },
                                      [_vm._v(_vm._s(_vm.$t("activityNoPrio")))]
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "font-weight-bold text-muted small text-uppercase mb-2 d-block"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("activityDescription")) +
                              "\n                      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "p-3 rounded border bg-white",
                          staticStyle: {
                            "min-height": "150px",
                            "max-height": "300px",
                            "overflow-y": "auto"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-break mb-0 small",
                              staticStyle: { "white-space": "pre-line" }
                            },
                            [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.activity.description ||
                                      _vm.$t("txtEmpty")
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.activity.file && _vm.activity.file.length
                    ? _c(
                        "div",
                        { staticClass: "row mx-0 border-top mt-3 pt-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("image-viewer", {
                                attrs: { medias: _vm.activity.file }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === 2,
                      expression: "tab === 2"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row mx-0" }, [
                    _vm._v(
                      "\n                        Task\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mx-0" },
                    [
                      _c("todo-list", {
                        attrs: {
                          json: _vm.todoJson,
                          cells: _vm.cells,
                          editable: false
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mx-0 mt-2" }, [
                    _c("div", { staticClass: "col-6 px-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function($event) {
                              _vm.tab--
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("txtPrev")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 px-0" })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "row w-100" }, [
                _c("div", { staticClass: "col-4" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary float-right",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("btnClose")) +
                          "\n                        "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }